import { useState } from "react";

export default function PaletteLibrary({ palettes, onClose, onDelete, onRename }) {
  const [renamingId, setRenamingId] = useState(null);
  const [renameVal,  setRenameVal]  = useState("");

  const commitRename = (pal) => {
    if (renameVal.trim() && renameVal.trim() !== pal.name) onRename?.(pal.id, renameVal.trim());
    setRenamingId(null);
  };

  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, zIndex:400, background:"rgba(0,0,0,.88)", backdropFilter:"blur(14px)", display:"flex", alignItems:"center", justifyContent:"center", animation:"fade-in .2s ease", fontFamily:"'DM Sans',sans-serif" }}>
      <div onClick={e=>e.stopPropagation()} style={{ width:"520px", maxHeight:"88vh", overflowY:"auto", background:"#0b0b1c", border:"1px solid rgba(255,255,255,.08)", borderRadius:"16px", boxShadow:"0 50px 120px rgba(0,0,0,.9)", animation:"panel-in .25s ease" }}>
        <div style={{ padding:"20px 24px 16px", borderBottom:"1px solid rgba(255,255,255,.05)", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, background:"#0b0b1c", zIndex:1, borderRadius:"16px 16px 0 0" }}>
          <div>
            <p style={{ fontFamily:"'Bebas Neue'", fontSize:"24px", letterSpacing:".15em", color:"#E8FF47" }}>PALETTE LIBRARY</p>
            <p style={{ fontFamily:"'DM Mono'", fontSize:"9px", color:"rgba(255,255,255,.22)", letterSpacing:".1em", textTransform:"uppercase", marginTop:"2px" }}>{palettes.length} saved</p>
          </div>
          <button onClick={onClose} style={{ width:"32px", height:"32px", borderRadius:"50%", border:"1px solid rgba(255,255,255,.1)", background:"transparent", color:"rgba(255,255,255,.4)", cursor:"pointer", fontSize:"14px" }}>x</button>
        </div>
        <div style={{ padding:"20px 24px 28px" }}>
          {palettes.length===0 ? (
            <div style={{ textAlign:"center", padding:"50px 0" }}>
              <p style={{ fontFamily:"'Bebas Neue'", fontSize:"28px", letterSpacing:".15em", color:"rgba(255,255,255,.07)" }}>EMPTY LIBRARY</p>
              <p style={{ fontFamily:"'DM Mono'", fontSize:"11px", color:"rgba(255,255,255,.2)", marginTop:"8px", lineHeight:"1.8" }}>Hover any image - DNA - Save Palette</p>
            </div>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", gap:"12px" }}>
              {palettes.map((pal,i)=>(
                <div key={pal.id} style={{ background:"rgba(255,255,255,.03)", border:"1px solid rgba(255,255,255,.06)", borderRadius:"12px", padding:"14px", animation:`pop .2s ease ${i*.05}s both` }}>
                  <div style={{ display:"flex", alignItems:"flex-start", gap:"12px" }}>
                    <div style={{ width:"48px", height:"48px", borderRadius:"8px", overflow:"hidden", flexShrink:0 }}>
                      <img src={pal.imageUrl} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }}/>
                    </div>
                    <div style={{ flex:1 }}>
                      <div style={{ display:"flex", alignItems:"baseline", justifyContent:"space-between", marginBottom:"8px" }}>
                        {renamingId === pal.id ? (
                          <input autoFocus value={renameVal}
                            onChange={e=>setRenameVal(e.target.value)}
                            onBlur={()=>commitRename(pal)}
                            onKeyDown={e=>{ if(e.key==="Enter") commitRename(pal); if(e.key==="Escape") setRenamingId(null); }}
                            style={{ fontFamily:"'DM Mono'", fontSize:"11px", color:"#E8FF47", background:"rgba(232,255,71,.06)", border:"1px solid rgba(232,255,71,.3)", borderRadius:"4px", padding:"2px 8px", outline:"none", flex:1, marginRight:"8px" }}
                          />
                        ) : (
                          <p onDoubleClick={()=>{ setRenamingId(pal.id); setRenameVal(pal.name||""); }} title="Double-click to rename"
                            style={{ fontFamily:"'DM Mono'", fontSize:"11px", color:"rgba(255,255,255,.7)", cursor:"text" }}>{pal.name}</p>
                        )}
                        <div style={{ display:"flex", gap:"8px", alignItems:"center", flexShrink:0 }}>
                          <p style={{ fontFamily:"'DM Mono'", fontSize:"9px", color:"rgba(255,255,255,.2)" }}>{pal.savedAt}</p>
                          <button onClick={()=>onDelete(pal.id)} style={{ background:"transparent", border:"none", color:"rgba(255,100,100,.4)", cursor:"pointer", fontSize:"11px" }}>x</button>
                        </div>
                      </div>
                      <div style={{ display:"flex", gap:"4px" }}>
                        {pal.colors.map((rgb,j)=>(
                          <div key={j} style={{ flex:1, height:"24px", borderRadius:"4px", background:`rgb(${rgb.join(",")})`, border:"1px solid rgba(255,255,255,.06)" }}/>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
